import React, { Fragment } from 'react'
import { Grid, Typography, Button } from '@mui/material'
import { PickingRouteAlert } from './PickingRouteAlert' // Ajusta la ruta según sea necesario.
import { useModal } from '../../hooks/useModal'
import { Modal } from '../../components/_EOS/Modal'

interface PickingRouteActionsBarProps {
  onPickingRouteAlertClick: () => void
  requestMasiveDeletePickingRoute: () => void
  disableDeleteButton: boolean
}

const PickingRouteActionsBar: React.FC<PickingRouteActionsBarProps> = ({
  onPickingRouteAlertClick,
  requestMasiveDeletePickingRoute,
  disableDeleteButton
}) => {
  const { isOpen, closeModal, title, openModal, size } = useModal(
    'Eliminar Rutas Seleccionadas',
    false,
    'xs'
  )

  const handleOpenDeleteModal = () => {
    openModal(size, undefined)
  }
  return (
    <Fragment>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={3} md={1} container alignItems='center'>
          <Typography variant='body2'>Pendiente Solución</Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <PickingRouteAlert onClickAlert={onPickingRouteAlertClick} />
        </Grid>
        <Grid
          item
          xs={12}
          sm={3}
          md={8}
          container
          justifyContent='flex-end'
          alignItems='flex-end'
        >
          <Button
            variant='contained'
            color='primary'
            onClick={handleOpenDeleteModal}
            disabled={disableDeleteButton}
          >
            Eliminar Rutas Seleccionadas
          </Button>
        </Grid>
      </Grid>

      <Modal
        title={title}
        open={isOpen}
        maxWidth={size}
        onClose={closeModal}
        successButton={{
          title: 'Eliminar',
          action: requestMasiveDeletePickingRoute
        }}
        cancelButton={{
          action: closeModal,
          title: 'Cancelar'
        }}
      >
        <Typography style={{ textAlign: 'center' }}>
          {`¿Está seguro que desea eliminar las rutas seleccionadas?`}
        </Typography>
      </Modal>
    </Fragment>
  )
}

export default PickingRouteActionsBar
